import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/home/qr-code.svg")